/**
 * Safe access to Vite-injected env.
 * Magic Patterns (and some hosts) leave `import.meta.env` undefined in the
 * browser bundle — never read properties without a guard.
 */
type ViteEnv = Record<string, string | boolean | undefined>;
function envObject(): ViteEnv {
  try {
    const meta = import.meta as ImportMeta & {
      env?: ViteEnv;
    };
    return meta.env && typeof meta.env === 'object' ? meta.env : {};
  } catch {
    return {};
  }
}
export function viteEnv(name: string): string | undefined {
  const value = envObject()[name];
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}